// 通用工具:copy() 复制、clipboardAvailable() 剪贴板可用性判断、pageVisible() 页面可见性
export async function copy(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}

// 剪贴板能不能用。
// ⚠️ 非 HTTPS(且不是 localhost)时 navigator.clipboard **整个对象不存在**,
//   直接调 navigator.clipboard.writeText 会同步抛 TypeError(不是 reject),
//   漏出去就是全局错误处理弹一个红色 JS 异常框,用户还以为是网站崩了。
export function clipboardAvailable() {
  try {
    return typeof navigator !== 'undefined' && !!navigator.clipboard && !!navigator.clipboard.writeText;
  } catch {
    return false;
  }
}

// 页面当前是否可见(切到别的标签页/最小化时为 false)。
// 轮询用它做闸门:页面看不见的时候没必要继续打接口 ——
// 管理员开着后台标签过夜,会白白打出成千上万次请求。
export function pageVisible() {
  try {
    return typeof document === 'undefined' || !document.hidden;
  } catch {
    return true;
  }
}
